module.exports = __webpack_public_path__ + "static/media/approve-1.10c82d18.svg";